import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
// import Datetime from 'react-datetime'

// Modals
// import PriceModelLogModal from '../../../../shared/modals/PriceModelLogModal'

// Actions
import { getPriceList, updatePriceList, getShopCustomerAgreement } from '../../../../actions/priceModel'
import { getCustomers } from '../../../../actions/customers'
import { triggerPopup } from '../../../../actions/backdrop'
import { getShopsForCustomerGroup, getShopCustomers } from '../../../../actions/customerGroup'
import { getBrands } from '../../../../actions/common'
import { getAgreementConstraint, createPriceAgreement } from '../../../../actions/agreementConstraint'
// formatCurrency, reverseFormatCurrency
import { formatCurrency2, reverseFormatCurrency2 } from '../../../../utils/currency'
import { transformPercent, onPercentFocus } from '../../../../utils/percent'

// import styles
import './insurance.scss'

// Utils
// formatCurrency, reverseFormatCurrency
import { hasAccess } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

// import components
import Portal from '../../../../shared/components/Portal'
import Confirm from '../../../../shared/components/Confirm'
// import HelpText from '../../../../shared/components/HelpText'

// Elements
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import Text from '../../../../shared/elements/text'
import Textarea from '../../../../shared/elements/textarea'
import Switch from '../../../../shared/elements/switch'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Grid from '../../../../shared/elements/grid'
import Button from '../../../../shared/elements/button'
import Radio from '../../../../shared/elements/radio'

class Insurance extends Component {
  constructor (props) {
    super(props)
    this.state = {
      constraint: {},
      price: props.agreementPrice !== undefined && props.agreementPrice.PriceModelId !== undefined ? props.agreementPrice : {
        Active: false,
        ActiveFromParent: false,
        Name: '',
        ParentPriceModelName: '',
        PriceCalculationType: 0,
        IsDeleted: false,
        IsEnvironmentDiscount: false,
        PriceDiscount: 0
      },
      agreementPrice: props.agreementPrice !== undefined && props.agreementPrice.PriceModelId !== undefined ? props.agreementPrice : undefined,
      confirm: {
        open: false,
        type: 0
      },
      confirmDelete: {
        open: false
      },
      confirmDeactivate: {
        open: false
      },
      confirmActivate: {
        open: false
      },
      selectedTabIndex: props.selectedTabIndex,
      isNew: true,
      selectedCustomerId: props.selectedCustomerId !== undefined && props.selectedCustomerId !== null ? props.selectedCustomerId : -1
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
    this.changeType = this.changeType.bind(this)
    this.onCreateAgreement = this.onCreateAgreement.bind(this)
    this.getPrice = this.getPrice.bind(this)
  }

  componentDidMount () {
    this.state.isCustomer = hasAccess([4], this.props.auth.user.UserType)
    this.state.isShop = hasAccess([3, 5, 7], this.props.auth.user.UserType)
    if (this.state.agreementPrice === undefined) {
      this.getPriceList(this.props)
    } else {
      console.log('setstateDidMount', this.state, this.props)
      this.setState({
        price: this.state.agreementPrice,
        priceOriginal: this.state.agreementPrice,
        isNew: false
      })
    }
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps.item, this.props.item)) {
      this.setState({
        priceOriginal: {},
        constraint: {},
        price: {
          Active: false,
          ActiveFromParent: false,
          Name: '',
          ParentPriceModelName: '',
          PriceCalculationType: 0,
          IsDeleted: false,
          IsEnvironmentDiscount: false,
          PriceDiscount: 0
        },
        confirm: {
          open: false,
          type: 0
        },
        confirmDelete: {
          open: false
        }
      }, () => {
        if (nextProps.item !== null && nextProps.item !== undefined) {
          console.log('getPriceList')
          this.getPriceList(nextProps)
        }
      })
    }
    // Get agreement again when clicking away from shops tab
    if (!isEqual(nextProps.selectedTabIndex, this.state.selectedTabIndex) && nextProps.selectedTabIndex === 0) {
      console.log('tab change')
      this.getPriceModel(nextProps, this.props.agreementId)
    }
    if (!isEqual(nextProps.selectedCustomerId, this.props.selectedCustomerId) && nextProps.selectedCustomerId > 0) {
      console.log('customer change')
      this.getCustomerAgreement(nextProps.agreementId, nextProps.selectedCustomerId)
    }
  }

  componentWillUpdate (nextProps) {
    // Fix to missing brands
    if (nextProps.brands === null || nextProps.brands.length === 0) {
      // this.props.getBrands()
    }
  }
  mapConstraints (constraint) {
    this.setState({
      price: {
        Active: false,
        ActiveFromParent: false,
        Name: constraint.Name,
        ParentPriceModelId: constraint.AgreementConstraintId,
        ParentPriceModelName: constraint.Name,
        WorkProvider: constraint.WorkProvider,
        PriceType: constraint.PriceType,
        CustomerGroupId: constraint.CustomerGroupId,
        BrandSelectionType: constraint.BrandSelectionType,
        PriceModelBrands: constraint.ConstraintBrands,
        Comment: constraint.Comment,
        PriceCalculationType: 0,
        IsDeleted: false,
        IsEnvironmentDiscount: false,
        PriceDiscount: 0,
        PriceHourly: 0
      },
      isNew: true
    })
  }
  getPrice (props, id) {
    props.getPriceList(id).then((res) => {
      this.setState({
        price: res.data,
        priceOriginal: res.data,
        isNew: false,
        constraint: {}
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }
  getCustomerAgreement (agreementId, customerId, companyId) {
    this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then((res) => {
      this.setState({
        price: res.data,
        priceOriginal: res.data,
        isNew: false,
        constraint: {}
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }
  getPriceModel (props, id) {
    if ((this.state.selectedCustomerId === -1 || props.selectedTabIndex === 0) && props.isMain && props.item !== null && props.item.PriceModelId > 0) {
      this.getPrice(props, id)
    } else if (props.item === null || Number(props.item.PriceModelId === undefined || props.item.PriceModelId <= 0)) {
      props.getAgreementConstraint(props.item.AgreementConstraintId).then((res) => {
        this.setState({
          constraint: res.data,
          isNew: true
        })
        this.mapConstraints(res.data)
      }, () => {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
        this.props.onShouldUpdate()
      })
    } else {
      this.getCustomerAgreement(id, this.state.selectedCustomerId, this.props.selectedShopId)
    }
  }

  getPriceList (props) {
    this.getPriceModel(props, props.item.PriceModelId)
  }

  shouldUpdatePrices (val1, val2) {
    return val1 !== val2
  }

  updatePrices (price) {
    const setPriceState = (data) => {
      this.setState({
        price: data,
        priceOriginal: data,
        isNew: false,
        constraint: {}
      })
    }
    return this.props.updatePriceList(price).then((res) => {
      setPriceState(res.data)
      // Toastr
      // window.toastr.success(translation('13444'), translation('13424'))
      // Return
      return res
    }, (err) => {
      // console.log('Error response ', err.response.data.Error)
      let errorDescription = null
      switch (err.response.data.Error) {
        case 1: // Conflict with existing
          errorDescription = '1793'
          break
        case 2: // Not allowed
          errorDescription = '1794'
          break
        case 1000: // Unspecified error
          errorDescription = '1795'
          break
      }
      if (errorDescription !== null) {
        // Toastr
        window.toastr.error(translation('13445') + ':</br>' + translation(errorDescription), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
      }

      // console.log('error ', err.response)
      setPriceState(err.response.data)
      // this.props.router.push('/prices')
      // Return
      return err
    })
  }

  onlyShow () {
    if (!hasAccess([6], this.props.auth.user.UserType)) {
      return true
    }
    return false
  }

  onInputChange (e) {
    e.persist()
    let value = e.target.value
    let name = e.target.name

    if (name === 'Active' && !e.target.checked) {
      this.setState({
        confirmDeactivate: {
          open: true
        }
      })
      return
    }
    if (name === 'ActiveFromParent') {
      if (e.target.checked && this.props.item.Active && !this.state.price.Active) {
        // link when main agreement active and sub agreement inactive
        this.setState({
          confirmActivate: {
            open: true
          }
        })
        return
      }
    }
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    if (name === 'selectedCustomerId') {
      // let id = this.props.item.PriceModelId
      this.setState({
        selectedCustomerId: value
      }, () => {
        if (Number(value) !== -1) this.getPrice(this.props, value)
      })
    } else if (name === 'PriceHourly') {
      this.setState({
        price: {
          ...this.state.price,
          PriceHourly: value
        }
      })
    } else {
      const val = (name === 'PriceDiscount') ? transformPercent(value, true) : value
      this.setState({
        price: {
          ...this.state.price,
          [e.target.name]: val
        }
      }, () => {
        if (e.target.type === 'checkbox') {
          this.updatePrices(this.state.price).then((res) => {
            if (name === 'Active') {
              this.props.getPriceLists(this.props)
            }
          })
        }
      })
    }
  }

  onCreateAgreement () {
    let data = {
      ParentPriceModelId: 0,
      CustomerGroupId: this.state.constraint.CustomerGroupId,
      AgreementConstraintId: this.state.constraint.AgreementConstraintId
    }
    this.props.createPriceAgreement(data).then((res) => {
      // window.toastr.success(translation('12271'), translation('13424'))
      this.props.onShouldUpdate()
      this.getPriceList(this.props)
      this.props.router.push('/agreements/' + this.state.constraint.AgreementConstraintId)
    }, (err) => {
      console.log(err)
      window.toastr.error(translation('12272'), translation('216'))
    })
  }

  onInputBlur (e) {
    let name = e.target.name
    if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
      if (name === 'PriceHourly') {
        let value = (e.target.value === '') ? '0' : e.target.value
        this.state.price.PriceHourly = reverseFormatCurrency2(value)
      }
      if (name === 'PriceDiscount') {
        let value = (transformPercent(e.target.value, true) === '') ? '0' : transformPercent(e.target.value, true)
        this.state.price.PriceDiscount = reverseFormatCurrency2(value)
      }
      this.updatePrices(this.state.price).then((res) => {
        if (name === 'Name') {
          this.props.getPriceLists(this.props)
        }
      })
    }
  }

  changeType (e) {
    let value = parseInt(e.target.value)
    this.setState({
      price: {
        ...this.state.price,
        [e.target.name]: value
      }
    }, () => {
      this.updatePrices(this.state.price).then((res) => {
        this.props.getPriceLists(this.props)
      })
    })
  }

  // Should render
  // Customer: 1 - Shop: 2
  shouldRender (type) {
    if (hasAccess([6], this.props.auth.user.UserType)) {
      return type === 2
    }
    // if (this.state.price.Name === null && this.state.price.CustomerId === 0 && type === 2) {
    if (this.state.price.CustomerId === 0 && type === 2) {
      return true
    }
    // if ((this.state.price.Name !== null || this.state.price.CustomerId !== 0) && type === 1) {
    if (this.state.price.CustomerId !== 0 && type === 1) {
      return true
    }
    return false
  }

  renderPriceCalculationTypes () {
    let { price } = this.state
    if (price.PriceType === 6 || price.PriceType === 0 || price.UseEstimationList) {
      return null
    }

    let isDisabled = !hasAccess([6], this.props.auth.user.UserType)
    let isWp = hasAccess([6], this.props.auth.user.UserType)

    // Return
    return (
      <Panel title={translation('1256')}>
        <Text
          name='PriceHourly'
          value={formatCurrency2(price.PriceHourly)}
          disabled={isDisabled}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          labelText={translation('419')}
        />

        <LabelWrapper labelText={translation('1256')}>
          <Radio name='PriceCalculationType' value='0' onChange={this.changeType} checked={price.PriceCalculationType === 0} disabled={!isWp} labelText={translation('12273')} helpText={translation('12274')} />
          <Radio name='PriceCalculationType' value='1' onChange={this.changeType} checked={price.PriceCalculationType === 1} disabled={!isWp} labelText={translation('12275')} helpText={translation('12276')} />
          <Radio name='PriceCalculationType' value='2' onChange={this.changeType} checked={price.PriceCalculationType === 2} disabled={!isWp} labelText={translation('12277')} helpText={translation('12278')} />
        </LabelWrapper>
      </Panel>
    )
  }

  renderDiscount () {
    let isCustomer = !hasAccess([6], this.props.auth.user.UserType)
    let { price } = this.state
    let pricediscount = formatCurrency2(price.PriceDiscount)

    return (
      <Panel title={translation('1197')}>
        <Text
          name='PriceDiscount'
          value={transformPercent(pricediscount)}
          disabled={isCustomer}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={onPercentFocus}
          labelText={translation('1199') + ' (%)'}
        />

        {price.PriceType !== 6 && (
          <Switch
            name='IsEnvironmentDiscount'
            onChange={this.onInputChange}
            checked={price.IsEnvironmentDiscount}
            disabled={isCustomer}
            labelText={translation('1236')}
          />
        )}
      </Panel>
    )
  }

  filterList (key) {
    return true
  }

  renderBrands () {
    let { price } = this.state
    let brands = price.PriceModelBrands

    return (
      <LabelWrapper labelText={translation('13473')}>
        <Radio name='BrandSelectionType' disabled checked={price.BrandSelectionType === 0} labelText={translation('381')} />
        <Radio name='BrandSelectionType' disabled checked={price.BrandSelectionType !== 0} labelText={translation('13475')} />

        {price.BrandSelectionType === 1 && (
          brands.map((b, key) => <div key={key}>{b.BrandName}</div>)
        )}
      </LabelWrapper>
    )
  }

  renderOrderTypes () {
    let isCustomer = (hasAccess([4, 6], this.props.auth.user.UserType))
    // let isCustomer = this.props.customer
    // if (hasAccess([6], this.props.auth.user.UserType)) return null
    if (hasAccess([3, 7], this.props.auth.user.UserType) && !this.props.customer) return null
    if (hasAccess([2], this.props.auth.user.UserType) && !this.props.partners) return null    // If chain creating work provider..
    // console.log('ordertype', this.props.auth.user.UserType)
    let { price } = this.state

    const renderOrderTypeInput = (value, key) => {
      let dictionaryKey
      switch (value) {
        case 0:
          dictionaryKey = '73'
          break
        case 5:
          dictionaryKey = '13360'
          break
        case 6:
          dictionaryKey = '301'
          break
        case 1:
          dictionaryKey = '71'
          break
        case 2:
          dictionaryKey = '785'
          break
        case 3:
          dictionaryKey = '13361'
          break
        case 8:
          dictionaryKey = '1396'
          break
      }

      return (
        <Radio
          name='PriceType'
          value={value}
          onChange={this.changeType}
          checked={price.PriceType === value}
          disabled={isCustomer}
          labelText={translation(dictionaryKey)}
          key={key}
        />
      )
    }

    // Return
    return (
      <LabelWrapper labelText={translation('525')}>
        {price.UseEstimationList
          ? [ 1, 2, 3, 8 ].map(renderOrderTypeInput)
          : [ 5, 6, 0 ].map(renderOrderTypeInput)}
      </LabelWrapper>
    )
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }

  renderAgreement () {
    // if (this.state.price.Name === null) return null
    const { price } = this.state
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let isWP = hasAccess([6], this.props.auth.user.UserType)
    let isShop = hasAccess([3, 5, 7], this.props.auth.user.UserType)
    let canDelete = !this.state.isNew && !isCustomer && !isWP && !isShop
    let canCreate = this.state.isNew
    let isMain = this.props.isMain !== undefined && this.props.isMain !== null && this.props.isMain && (hasAccess([6], this.props.auth.user.UserType))
    // let name = price.Name
    // let isWP = false // hasAccess([6], this.props.auth.user.UserType) && this.state.selectedShopId !== -1
    // if (this.state.selectedCustomerId !== -1) name = price.ParentPriceModelName
    // let isCustomer = this.props.customer
    const onDelete = () => {
      this.setState({
        confirmDelete: {
          open: true
        }
      })
    }

    let priceList
    if (price.UseEstimationList) {
      priceList = translation('433')
    } else {
      priceList = price.ParentPriceModelName || translation('433')
    }

    return (
      <Panel title={translation('13472')}>
        <Text name='Name' value={price.Name} disabled={isCustomer} onBlur={this.onInputBlur} labelText={translation('30')} />
        <Textarea name='Comment' value={price.Comment} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isCustomer || isShop} labelText={translation('149')} />
        <Switch name='Active' checked={price.Active} onChange={this.onInputChange} disabled={this.state.isNew || isCustomer || isShop} labelText={translation('295')} />
        { isWP && !isMain && <Switch name='ActiveFromParent' onChange={this.onInputChange} checked={price.ActiveFromParent} disabled={isCustomer || isShop} labelText={translation('16673')} /> }
        {this.renderOrderTypes()}
        {this.renderBrands()}

        <LabelWrapper labelText={translation('1867')}>
          {priceList}
        </LabelWrapper>

        <Grid>
          {canDelete && <Button onClick={onDelete} labelText={translation('12279')} />}
          {canCreate && <Button onClick={this.onCreateAgreement} labelText={translation('12280')} />}
        </Grid>
      </Panel>
    )
  }

  render () {
    console.log('here')
    if (this.props.selectedTabIndex === 1 && this.state.selectedCustomerId < 0) {
      return null
    }
    const confirmDeactivate = (props) => {
      let ctext = this.props.isMain && hasAccess([6], this.props.auth.user.UserType) ? props.t('12267') : props.t('403')
      if (!this.props.isMain && hasAccess([6], this.props.auth.user.UserType) && this.state.price.ActiveFromParent) {
        ctext = props.t('16675')
      }
      return (
        <div>
          {ctext}
        </div>
      )
    }
    const confirmActivate = (props) => {
      let ctext = props.t('16674')
      return (
        <div>
          {ctext}
        </div>
      )
    }

    return (
      <div>
        <fieldset disabled={this.props.creating}>
          <Col>
            {this.renderAgreement()}
          </Col>
          <Col>
            {!this.state.isNew && this.renderPriceCalculationTypes()}
            {!this.state.isNew && this.renderDiscount()}
          </Col>
        </fieldset>

        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirm.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
        {this.state.confirmDeactivate.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDeactivate')}>
            <Confirm confirm={this.onConfirmDeactivate.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDeactivate')} higher renderText={confirmDeactivate} />
          </Portal>
        )}
        {this.state.confirmActivate.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmActivate')}>
            <Confirm confirm={this.onConfirmActivate.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmActivate')} higher renderText={confirmActivate} />
          </Portal>
        )}
      </div>
    )
  }

  onConfirmActivate () {
    this.onPortalClose('confirmActivate')
    this.setState({
      price: {
        ...this.state.price,
        Active: true,
        ActiveFromParent: true
      }
    }, () => {
      this.updatePrices(this.state.price).then((res) => {
        // this.props.getPriceLists(this.props)
      })
    })
  }

  onConfirmDeactivate () {
    this.onPortalClose('confirmDeactivate')
    this.setState({
      price: {
        ...this.state.price,
        Active: false,
        ActiveFromParent: false // only applies to sub agreements - check in backend
      }
    }, () => {
      this.updatePrices(this.state.price).then((res) => {
        // this.props.getPriceLists(this.props)
      })
    })
  }

  onConfirm () {
    this.onPortalClose('confirmDelete')
    let price = { ...this.state.price }
    price.IsDeleted = true
    this.updatePrices(price).then(() => {
      this.props.onShouldUpdate()
    })
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers,
    companies: state.common.companies,
    brands: state.common.brands
  }
}

export default connect(mapStateToProps, {
  getPriceList,
  updatePriceList,
  getCustomers,
  // getPriceModelLog,
  triggerPopup,
  getBrands,
  getShopsForCustomerGroup,
  getShopCustomerAgreement,
  getShopCustomers,
  getAgreementConstraint,
  createPriceAgreement
})(Insurance)



// WEBPACK FOOTER //
// ./src/app/pages/PriceAgreements/Agreements/Insurance/index.js